// Dependecies
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// store
import user from '../../store/user';

function useRegister(clearErrors, setError, locale, reset) {
  const [t] = useTranslation('routers', 'alert', { useSuspense: false });
  const history = useHistory();
  const [, userActions] = user();
  const [messageError, setMessageError] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [isBlockedModal, setIsBlocked] = useState(false);

  const submit = async (data) => {
    setIsBlocked(false);
    const userData = {
      /* User data */
      name: data.name,
      role_id: 3,
      email: data.email,
      password: data.password,
      password_confirmation: data.c_password,
      /* Company data  */
      phone: data.phone_company,
      rut: data.rut_company,
      id_city: data.city,
      adviser: data.adviser,
      /* Email data */
      template: 'verify_email',
    };

    userActions.register(userData, locale).then(
      () => {
        setOpenModal(true);
        reset();
      },
      (e) => {
        if (e.email) {
          setMessageError(1);
        } else if (e.nit) {
          setMessageError(2);
        } else if (e.rut) {
          setMessageError(3);
        } else if (e.error && e.error.message.includes('user_all_document_unique')) {
          setMessageError(4);
        } else {
          setMessageError(5);
        }
      }
    );
  };
  const closeModal = () => {
    setOpenModal(false);
  };

  const acceptModal = () => {
    setOpenModal(false);
    history.push(`${t('Login')}`);
  };

  function validatePassword(value, watch, referent) {
    if (value === '') {
      return `${t('alert:password-empty')}`;
    }
    if (value !== watch) {
      setError(referent, 'validate', `${t('alert:password-match')}`);
      return `${t('alert:password-match')}`;
    }

    clearErrors('c_password');
    clearErrors('password');

    return true;
  }

  return {
    openModal,
    closeModal,
    acceptModal,
    submit,
    validatePassword,
    messageError,
    isBlockedModal,
    setIsBlocked,
  };
}

export default useRegister;
